export default __webpack_public_path__ + "static/media/cta.bf5de966.jpg";